import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { UserService } from '@app/user/services';
import { Division } from '@usf/customer-types';
import { Observable, Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { CustomerStoreService } from 'src/app/ngrx-customer/services';
import { environment } from '../../../../environments/environment';
import { PATHS } from '../../constants/paths';
import { FEATURES } from '../../constants/splitio-features';
import { NavigationHelperService } from '../../helpers/navigation.helpers.service';
import { DivisionPhoneNumberService } from '@shared/services/division-phone-number/division-phone-number.service';
import { OrderService } from '@order/services/order.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  serviceRequestFeatureFlag$: Observable<Boolean>;
  readonly requestCreditPath = PATHS.REQUEST_CREDIT;

  divisionInfo$: Observable<Division>;
  divisionPhoneNumber$: Observable<string>;
  isGuestUser$: Observable<boolean>;

  careersUrl: String;
  foodFanaticsUrl: String;
  ourBrandsUrl: String;
  divisionPhoneNumber: string;
  currentYear: number;

  manageCustomizationsLogo: boolean;

  constructor(
    private router: Router,
    readonly platformService: PlatformService,
    private customerStoreService: CustomerStoreService,
    readonly panAppState: PanAppState,
    // private i18n: I18nConfigService, //for demo only
    readonly navigationHelperService: NavigationHelperService,
    private divisionPhoneNumberService: DivisionPhoneNumberService,
    readonly orderService: OrderService,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    this.customizationsFlag();
    this.isGuestUser$ = this.userService.isGuestUser$();

    this.panAppState?.customer$
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        this.divisionInfo$ =
          this.customerStoreService.loadDivisionByDivisionNumber$(
            res?.divisionNumber,
          );
        this.divisionPhoneNumber$ = this.divisionPhoneNumberService
          .getDivisionPhoneNumber$(
            res?.customerType === 'NA',
            res?.divisionNumber,
          )
          ?.pipe(map(phoneNumber => phoneNumber));
      });

    this.serviceRequestFeatureFlag$ = this.panAppState
      .feature$([FEATURES.split_global_service_request.name])
      .pipe(takeUntil(this.destroy$));

    this.careersUrl = environment.careersUrl;
    this.foodFanaticsUrl = environment.foodFanaticsUrl;
    this.ourBrandsUrl = environment.ourBrandsUrl;
  }

  customizationsFlag() {
    this.panAppState
      .feature$([FEATURES.split_global_user_customizations.name])
      .pipe(takeUntil(this.destroy$))
      .subscribe(on => {
        this.manageCustomizationsLogo = on;
      });
  }

  navigationHandler(url: string): void {
    this.router.navigate([url]);
  }

  /**
   * For demo purpose only
   */
  // changeLanguage() {
  //   this.i18n.changeLanguageForDemoOnly();
  // }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
